var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrahp1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 104,
    viewBox: "0 0 137 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7777_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.748 83.1628H24.252C21.904 83.1628 20 81.5024 20 79.4537V23.7091C20 21.6609 21.9035 20 24.252 20H112.748C115.096 20 117 21.6604 117 23.7091V79.4537C117 81.5024 115.096 83.1628 112.748 83.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.601 32.2051H30.0645C28.9524 32.2051 28.0508 31.3035 28.0508 30.1914C28.0508 29.0794 28.9524 28.1777 30.0645 28.1777H106.601C107.713 28.1777 108.614 29.0794 108.614 30.1914C108.615 31.3035 107.713 32.2051 106.601 32.2051Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3185 32.2051H30.0645C28.9524 32.2051 28.0508 31.3035 28.0508 30.1914C28.0508 29.0794 28.9524 28.1777 30.0645 28.1777H77.3185C78.4306 28.1777 79.3322 29.0794 79.3322 30.1914C79.3322 31.3035 78.4306 32.2051 77.3185 32.2051Z",
    fill: "#19C3CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.601 43.2803H30.0645C28.9524 43.2803 28.0508 42.3787 28.0508 41.2666C28.0508 40.1546 28.9524 39.2529 30.0645 39.2529H106.601C107.713 39.2529 108.614 40.1546 108.614 41.2666C108.615 42.3787 107.713 43.2803 106.601 43.2803Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2793 43.2803H30.0645C28.9524 43.2803 28.0508 42.3787 28.0508 41.2666C28.0508 40.1546 28.9524 39.2529 30.0645 39.2529H59.2788C60.3908 39.2529 61.2925 40.1546 61.2925 41.2666C61.293 42.3787 60.3913 43.2803 59.2793 43.2803Z",
    fill: "#FF8F9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.601 54.3555H30.0645C28.9524 54.3555 28.0508 53.4539 28.0508 52.3418C28.0508 51.2298 28.9524 50.3281 30.0645 50.3281H106.601C107.713 50.3281 108.614 51.2298 108.614 52.3418C108.615 53.4539 107.713 54.3555 106.601 54.3555Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.777 54.3555H30.0645C28.9524 54.3555 28.0508 53.4539 28.0508 52.3418C28.0508 51.2298 28.9524 50.3281 30.0645 50.3281H101.776C102.889 50.3281 103.79 51.2298 103.79 52.3418C103.79 53.4539 102.889 54.3555 101.777 54.3555Z",
    fill: "#4925AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.601 65.4307H30.0645C28.9524 65.4307 28.0508 64.5291 28.0508 63.417C28.0508 62.305 28.9524 61.4033 30.0645 61.4033H106.601C107.713 61.4033 108.614 62.305 108.614 63.417C108.615 64.5296 107.713 65.4307 106.601 65.4307Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7149 65.4307H30.0645C28.9524 65.4307 28.0508 64.5291 28.0508 63.417C28.0508 62.305 28.9524 61.4033 30.0645 61.4033H43.7149C44.8269 61.4033 45.7286 62.305 45.7286 63.417C45.7286 64.5296 44.8269 65.4307 43.7149 65.4307Z",
    fill: "#D68D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.601 76.5059H30.0645C28.9524 76.5059 28.0508 75.6043 28.0508 74.4922C28.0508 73.3802 28.9524 72.4785 30.0645 72.4785H106.601C107.713 72.4785 108.614 73.3802 108.614 74.4922C108.615 75.6048 107.713 76.5059 106.601 76.5059Z",
    fill: "#E7E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1215 76.5059H30.0645C28.9524 76.5059 28.0508 75.6043 28.0508 74.4922C28.0508 73.3802 28.9524 72.4785 30.0645 72.4785H88.1215C89.2336 72.4785 90.1352 73.3802 90.1352 74.4922C90.1352 75.6048 89.2341 76.5059 88.1215 76.5059Z",
    fill: "#CC197E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7777_609",
    x: 0,
    y: 0,
    width: 137,
    height: 103.163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7777_609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7777_609",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrahp1);
export default __webpack_public_path__ + "static/media/grahp1.9d7dda2eef476b2d16ea57beb92df807.svg";
export { ForwardRef as ReactComponent };